import { Component, OnInit } from '@angular/core';
import { CitaLaboratorioEntity, CitaLaboratorioBodyEntity, ServicioLaboratorioService } from 'src/app/services/servicio-laboratorio.service';
import { ActivatedRoute } from '@angular/router';
import { ImagesService } from 'src/app/services/utils/images.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-citas-laboratorio',
  templateUrl: './reporte-citas-laboratorio.component.html',
  styleUrls: ['./reporte-citas-laboratorio.component.css']
})
export class ReporteCitasLaboratorioComponent implements OnInit {

  loading = false;
  logo: string;
  user: string;
  fechaImpresion: Date;

  filtrosSeleccionados: CitaLaboratorioEntity;
  detalle: CitaLaboratorioBodyEntity[] = [];

  public objectCita: CitaLaboratorioEntity = {
    codigo : '',
    fechaInicial : 0,
    fechaFinal : 0,
    sedePuntoAtencion : -1,
    descripcionSedePuntoAtencion : ''
  };

  constructor( private activatedRoute: ActivatedRoute ,
               private servicioImagenes: ImagesService ,
               private servicioLaboratorio: ServicioLaboratorioService) {
    this.activatedRoute.params.subscribe(params => {
      this.objectCita.codigo = params['codigoBaseDatos'];
      this.objectCita.sedePuntoAtencion = params['spa'];
      this.user = params['user'];
    });
  }

  ngOnInit() {
    this.filtrosSeleccionados = this.objectCita;
    this.getLogo(this.objectCita.codigo);
    this.fechaImpresion = new Date();
  }

  public onFiltrosCompleados(obj: CitaLaboratorioEntity) {
    this.loading = true;
    this.filtrosSeleccionados = obj;
    this.fechaImpresion = new Date();
    this.getLogo(obj.codigo);
    this.getData();
  }

  async getLogo(codigoBaseDatos: string) {
    try {
      this.logo = '';
      const response = await this.servicioImagenes.getLogo(codigoBaseDatos);
      if (response != null) {
        response.subscribe((data: any) => {
          this.logo = data.source;
        }, (err: HttpErrorResponse) => {
          this.logo = '';
        });
      }
    } catch (e) {
      this.logo = '';
    }
  }

  async getData() {
    try {
      const response = await this.servicioLaboratorio.getCitaData(this.filtrosSeleccionados);
      if (response != null) {
        response.subscribe((data: CitaLaboratorioBodyEntity[]) => {
          this.detalle = data;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.error(err);
        });
      }
    } catch (e) {
      console.error(e);
      this.loading = false;
    }
  }

}
